__turbopack_context__.v({
  "icon": "index-module-scss-module__G5esja__icon",
  "locked": "index-module-scss-module__G5esja__locked",
  "message": "index-module-scss-module__G5esja__message",
  "title": "index-module-scss-module__G5esja__title",
});
